import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
// Import Contexts
import { ProgramConfigContext } from '../../../../contexts/ProgramConfigContext';
// Import Global Components
import Heading from '../../../../components/Heading';
// Import Component Styles
import { HeadingTabs, HeadingWrapper } from '../../styles';
import TransfersCard from './components/TransfersCard';

const TransferHistory = () => {
  const intl = useIntl();
  const configs = useContext(ProgramConfigContext);
  const page = 'transfer-history';
  return (
    <>
      <HeadingWrapper>
        <HeadingTabs>
          <Link to="/transfers">
            <Heading
              page="transfer"
              heading={intl.messages['transfer-heading']}
            />
          </Link>
          <Heading
            page="transfer-history"
            heading={intl.messages['transfer-history-heading']}
            className="active"
          />
          {configs.allow_external_transfers_v2 && (
            <Link to="/transfers/external-accounts">
              <Heading
                page="external-accounts"
                heading={intl.messages['external-accounts-heading']}
              />
            </Link>
          )}
        </HeadingTabs>
      </HeadingWrapper>
      <TransfersCard page={page} />
    </>
  );
};

export default TransferHistory;
